"use client";
import { useEffect } from "react";

declare global {
  interface Window {
    ym?: (...args: any[]) => void;
  }
}

const useYandexMetrika = (ymId: number | string) => {
  useEffect(() => {
    if (typeof window === "undefined") return;
    (function (
      m: Window & { [key: string]: any },
      e: Document,
      t: string,
      r: string,
      i: string
    ) {
      if (m[i] !== undefined) return;

      const s = e.createElement(t) as HTMLScriptElement;
      const f = e.getElementsByTagName(t)[0];

      s.async = true;
      s.src = r;
      f?.parentNode?.insertBefore(s, f);

      m[i] = function (...args: any[]) {
        m[i].a = m[i].a || [];
        m[i].a.push(args);
      };
    })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

    window.ym?.(ymId, "init", {
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
      ecommerce: "dataLayer",
    });
  }, [ymId]);
};

export default useYandexMetrika;
